import DropdownOptions from "../../constants/DropdownOptions";
import { USER } from "./action";

const initialState = {
  usersList: [],
  selectedUserType: DropdownOptions.ALL_USERS[0].id
};

export default function userManagementReducer(state = initialState, action) {
  switch (action.type) {
    case USER.list.success:
      return {
        ...state,
        usersList: action.data
      };
      case USER.list.error:
      return {
        ...state,
        usersList: []
      };
      case USER.edit.success:
      return {
        ...state,
        selectedUser: action.data
      };
    case USER.update.success:
      return {
        ...state,
        userUpdated: action.data
      };
    case USER.disable.success:
      return {
        ...state
        //userUpdated: action.data
      };
    case USER.enable.success:
      return {
        ...state
        //userUpdated: action.data
      };
    case USER.delete.success:
      const userId = action.data.id;
      return {
        ...state,
        usersList: state.usersList.filter(user => user.id !== userId)
      };
    case USER.changePassword.start:
    return {
      ...state,
      selectedUser: action.data
    };
    case USER.changePassword.success:
      return {
        ...state,
        userUpdated: action.data
      };
    case USER.userType.success:
        return {
          ...state,
          selectedUserType: action.data
        }; 
    case USER.resetState.reset:
      return {
        ...initialState
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/userManagement/reducer.js